module.exports = __webpack_public_path__ + "img/box-upgrade.af63a78d.svg";